<template>
  <div class="sign">
    <swipeComponents></swipeComponents>
    <div class="title">请填写您的报名信息</div>
    <van-cell-group>
      <van-field
        v-model="form.distance"
        label="所属区"
        placeholder="请选择所属区"
        :label-width="labelWidth"
        required
        :readonly="true"
        @click="openAreaPopup"
      />
      <van-field
        v-model="form.applyUserName"
        label="姓名"
        placeholder="请输入姓名"
        :label-width="labelWidth"
        required
      />
      <van-field
        v-model="form.applyDuty"
        label="职务"
        placeholder="请输入职务"
        :label-width="labelWidth"
      />
      <van-field
        v-model="form.applyCompany"
        label="单位/孵化器名称"
        placeholder="请输入单位/孵化器名称"
        :label-width="labelWidth"
        required
      />
      <van-field
        v-model="form.applyPhone"
        label="电话"
        placeholder="请输入电话"
        :label-width="labelWidth"
        required
      />
    </van-cell-group>
    <div class="btns">
      <van-button type="primary" block @click="submit">
        提 交
      </van-button>
    </div>

    <noticeBox></noticeBox>

    <van-popup
      v-model="showAreaPopup"
      position="bottom"
      :style="{ height: 'auto' }"
    >
      <van-picker
        show-toolbar
        title="请选择"
        :columns="areas"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Field, CellGroup, Button, Popup, Picker } from "vant";
import { getApplyInfo, editApplyInfo } from "@/api";
import swipeComponents from "@/components/swipe.vue";
import noticeBox from "@/components/Notice.vue";
export default {
  name: "Sign",
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    swipeComponents,
    noticeBox
  },
  data() {
    return {
      labelWidth: "120",
      showAreaPopup: false,
      form: {
        distance: "",
        applyUserName: "",
        applyDuty: "",
        applyCompany: "",
        applyPhone: ""
      },
      areas: [
        "泉山区",
        "云龙区",
        "鼓楼区",
        "贾汪区",
        "铜山区",
        "新沂市",
        "邳州市",
        "睢宁县",
        "丰县",
        "沛县",
        "徐州经济技术开发区",
        "徐州高新区",
        "徐州淮海国际港务区"
      ]
    };
  },
  methods: {
    submit() {
      if (!this.form.distance) {
        this.$toast("请选择所属区");
        return false;
      }
      if (!this.form.applyUserName) {
        this.$toast("请输入姓名");
        return false;
      }
      if (!this.form.applyCompany) {
        this.$toast("请输入公司名称");
        return false;
      }
      if (!this.form.applyPhone) {
        this.$toast("请输入电话");
        return false;
      }
      if (!this.$feng.validatePhone(this.form.applyPhone)) {
        this.$toast("手机号格式不正确");
        return false;
      }

      let params = this.form;
      editApplyInfo(params)
        .then(res => {
          // console.log(res);
          if (res.status == 200) {
            // this.goGetApplyInfo();
            this.$toast(res.msg);
            this.$router.replace({ path: "/mysign" });
          } else {
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          this.$toast("网络错误");
        });
    },
    edit() {},
    goGetApplyInfo() {
      getApplyInfo()
        .then(res => {
          // console.log(res);
          if (res.status == 200) {
            this.form.applyUserName = res.data.applyUserName;
            this.form.applyDuty = res.data.applyDuty;
            this.form.applyCompany = res.data.applyCompany;
            this.form.applyPhone = res.data.applyPhone;
            this.form.distance = res.data.distance;
          }
        })
        .catch(() => {});
    },
    onConfirm(val) {
      this.form.distance = val;
      this.onCancel();
    },
    onCancel() {
      this.showAreaPopup = false;
    },
    openAreaPopup() {
      this.showAreaPopup = true;
    }
  },
  created() {
    this.goGetApplyInfo();
  }
};
</script>

<style lang="stylus" scoped>
.sign
  .btns
    padding 0 15px
    margin-top 40px
    .van-button
      margin-top 10px
  .title
    font-size 24px
    font-weight bold
    text-align center
    line-height 68px
</style>
